import { render, staticRenderFns } from "./b2bprovajderi.editor.vue?vue&type=template&id=585832fd&scoped=true&"
import script from "./b2bprovajderi.editor.vue?vue&type=script&lang=ts&"
export * from "./b2bprovajderi.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585832fd",
  null
  
)

export default component.exports